import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective, NkCardListItemAbstractComponent } from '@nk/ui-lib';
import { LOADING_STATE_HANDLER_SERVICE_TOKEN } from '@nk/utils-lib';
import { isAllScreeningCaseReviewsCompleted } from '../../utils/screening-case.utils';
import { ScreeningCaseCardListItem } from '../screening-case-card-list/screening-case-card-list.utils';

@Component({
  selector: 'nk-screening-case-card-action-list-item',
  imports: [TranslateModule, ButtonDirective],
  templateUrl: './screening-case-card-action-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreeningCaseCardActionListItemComponent
  extends NkCardListItemAbstractComponent<ScreeningCaseCardListItem, 'screeningCaseComposite'>
  implements OnInit
{
  private _router = inject(Router);
  private _activatedRoute = inject(ActivatedRoute);
  private _reportLoadingStateService = inject(LOADING_STATE_HANDLER_SERVICE_TOKEN, { optional: true });
  public isPrintVersion = signal<boolean>(false);

  public item = computed(() => {
    const value = this.valueSignal();
    if (value && value.entity) {
      // prop is guaranteed to be 'action' due to generic type parameter
      const item = value.entity[value.prop];
      if (item) {
        return item;
      }
    }
    return null;
  });

  public isAllScreeningCaseReviewsCompleted = computed(() => {
    const item = this.item();
    if (item) {
      return isAllScreeningCaseReviewsCompleted(item);
    }
    return null;
  });
  public screeningEntityUuid = computed(() => {
    const item = this.item();
    if (item) {
      return item?.screening_entity?.uuid;
    }
    return null;
  });

  public ngOnInit(): void {
    if (this._reportLoadingStateService) {
      this.isPrintVersion.set(true);
    }
  }

  public openScreeningCaseReview(screeningEntityUuid: string): void {
    const item = this.item();
    if (item?.screening_entity?.entity_key === 'person') {
      void this._router.navigate(['/person', item.screening_entity.entity_uuid, 'screening']);
      return;
    }
    const url = ':screeningEntityUuid/screening-cases'.replace(':screeningEntityUuid', screeningEntityUuid);
    void this._router.navigate([url], {
      relativeTo: this._activatedRoute,
    });
  }
}
